// Stub: expo-calendar — native calendar not available on web/desktop
const noop = () => Promise.resolve(null);
const denied = () => Promise.resolve({ status: 'denied', granted: false, canAskAgain: false });

// ── Permissions (both old and new API names) ──────────────────────────────────
export const getPermissionsAsync            = denied;
export const requestPermissionsAsync        = denied;
export const getCalendarPermissionsAsync    = denied;
export const requestCalendarPermissionsAsync = denied;
export const getRemindersPermissionsAsync   = denied;
export const requestRemindersPermissionsAsync = denied;

// ── Calendars / events ────────────────────────────────────────────────────────
export const getCalendarsAsync  = () => Promise.resolve([]);
export const getEventsAsync     = () => Promise.resolve([]);
export const createEventAsync   = noop;
export const updateEventAsync   = noop;
export const deleteEventAsync   = noop;
export const createCalendarAsync = noop;
export const deleteCalendarAsync = noop;

// ── Reminders ─────────────────────────────────────────────────────────────────
export const getRemindersAsync  = () => Promise.resolve([]);
export const createReminderAsync = noop;
export const updateReminderAsync = noop;
export const deleteReminderAsync = noop;

// ── Constants ─────────────────────────────────────────────────────────────────
export const EntityTypes = { EVENT: 'event', REMINDER: 'reminder' };
export const CalendarType = { LOCAL: 'local', CALDAV: 'caldav', EXCHANGE: 'exchange', GOOGLE: 'google', BIRTHDAY: 'birthday' };
export const ReminderStatus = { INCOMPLETE: 'incomplete', COMPLETED: 'completed' };
export const Frequency = { DAILY: 'daily', WEEKLY: 'weekly', MONTHLY: 'monthly', YEARLY: 'yearly' };
export const Availability = { BUSY: 'busy', FREE: 'free', TENTATIVE: 'tentative', UNAVAILABLE: 'unavailable' };

export default {
  getPermissionsAsync, requestPermissionsAsync,
  getCalendarPermissionsAsync, requestCalendarPermissionsAsync,
  getRemindersPermissionsAsync, requestRemindersPermissionsAsync,
  getCalendarsAsync, getEventsAsync, createEventAsync, updateEventAsync, deleteEventAsync,
  createCalendarAsync, deleteCalendarAsync,
  getRemindersAsync, createReminderAsync, updateReminderAsync, deleteReminderAsync,
  EntityTypes, CalendarType, ReminderStatus, Frequency, Availability,
};
